﻿import { Typography } from 'antd';
import { Coordinate } from 'ol/coordinate';
import Map from 'ol/Map';
import React, { useEffect, useState } from 'react';
import MapPopup, { IMapPopupTarget } from '../../MapPopup';

import './PickReport.less';

interface Props  {
    map: Map,
    coordinate: Coordinate | undefined,
    label?: string
}

const PickReportMarker: React.FC<Props> = ({
    map,
    coordinate,
    label = 'Pick report'
}) => {

    const [target, setTarget] = useState<IMapPopupTarget>();

    useEffect(() => {
        if (coordinate) {
            setTarget({
                coordinate: coordinate,
                content: <Typography.Text strong style={{ whiteSpace: "nowrap" }}>{ label }</Typography.Text>
            })
        }
        else {
            setTarget(undefined);
        }
    }, [coordinate, label]);    

    return (
        <MapPopup
            map={map}
            target={target}
            anchor={{
                className: 'pick-report-marker-badge',
                dot: true,
                color: "blue"
            }}
            maxWidth={20}
            minWidth={20}
        />
    )
}

export default PickReportMarker;